import { Handle, Position, NodeResizer, type NodeProps } from "@xyflow/react";
import { XCircle } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const EndNode = ({ data, selected }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.end');
    return (
        <div className="rounded-lg bg-utility-error-50 border-2 border-utility-error-500 shadow-md min-w-[120px] w-full h-full">
            <NodeResizer
                color="#ef4444"
                isVisible={selected}
                minWidth={120}
                minHeight={50}
            />
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-error-500" />
            <div className="flex items-center gap-2 px-3 py-2 h-full justify-center flex-wrap">
                <XCircle className="size-4 text-utility-error-600 flex-shrink-0" />
                <span className="text-sm font-semibold text-utility-error-700 break-words">{label}</span>
            </div>
        </div>
    );
};
